var CatalogSorting = function (el) {
  this.$el = $(el);
  this.$el.find('form .apply-sorting').click(function (evt) {
    evt.preventDefault();
    this.onSortingChange(this.$el.find('form').get(0).elements.sort.value);
  }.bind(this));
  this.$el.find('ul a').click(function (evt) {
    evt.preventDefault();
    this.onSortingChange(evt.target.dataset.sortType);
  }.bind(this));
};

CatalogSorting.prototype.onSortingChange = function (sortingType) {
  if (!sortingType) return;
  var sortQuery = "sort=" + sortingType;
  if (location.search.indexOf("sort") === -1) {
    location.search += ("&" + sortQuery);
  } else {
    var start = location.search.indexOf("sort");
    var end = location.search.indexOf("&", start);
    var replace = end === -1 ? location.search.substr(start, location.search.length) : location.search.substr(start, end - start);
    location.search = location.search.replace(replace, sortQuery)
  }
};

$(function () {
  $('.catalog-sorting').each(function () {
    new CatalogSorting(this);
  })
});